module.exports = __webpack_public_path__ + "img/groups-icon-dark.7f1629ad.svg";